export function monthlyReminderDay(fieldValue: string) {
  return fieldValue && (Number(fieldValue) > 28 || Number(fieldValue) < 1)
    ? 'Choose a day from 1 to 28'
    : undefined;
}
